import React, { useState } from "react";
import RowContainer from "../../../../../common/RowContainer";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  AreaChart,
  Area,
} from "recharts";
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import "./CustomLineChart.less";
import ColumnContainer from "../../../../../common/ColumnContainer";
import { FormattedMessage, useIntl } from "react-intl";

const CustomLineChart = ({ statisticsProjects }) => {
  const [period, setPeriod] = useState("current");
  const intl = useIntl();

  const handlePeriodChange = (event, newPeriod) => {
    if (newPeriod !== null) {
      setPeriod(newPeriod);
    }
  };
  const currentYear = new Date()?.getFullYear();

  const currentLabel = intl.formatMessage({
    id: "dashboard.completedProjects.current",
  });
  const previousLabel = intl.formatMessage({
    id: "dashboard.completedProjects.previous",
  });

  return (
    <ColumnContainer className="custom-line-chart-proj" padding="20px">
      <RowContainer align="center">
        <Typography variant="h6" component="h6" color="var(--main-color)">
          <FormattedMessage id="dashboard.completedProjects" />
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ToggleButtonGroup
            value={period}
            exclusive
            onChange={handlePeriodChange}
            aria-label="text alignment"
          >
            <ToggleButton
              value="current"
              aria-label={
                <FormattedMessage id="dashboard.completedProjects.current" />
              }
              sx={{
                backgroundColor: "var(--bkg-secondary)",
                color: "var(--main-color)",
              }}
            >
              <FormattedMessage id="dashboard.completedProjects.current" />:{" "}
              {currentYear}
            </ToggleButton>
            <ToggleButton
              value="previous"
              aria-label={
                <FormattedMessage id="dashboard.completedProjects.previous" />
              }
              sx={{
                backgroundColor: "var(--bkg-secondary)",
                color: "var(--main-color)",
              }}
            >
              <FormattedMessage id="dashboard.completedProjects.previous" />:{" "}
              {currentYear - 1}
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </RowContainer>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={statisticsProjects} stackOffset="none">
          <CartesianGrid strokeDasharray="3 3" stroke="#444" />
          <XAxis dataKey="month" stroke="#ccc" />
          <YAxis stroke="#ccc" interval={1} />
          <Tooltip />
          <Legend
            verticalAlign="top"
            height={36}
            formatter={(value) => {
              if (value === "current") return currentLabel;
              if (value === "previous") return previousLabel;
              return value;
            }}
          />
          <defs>
            <linearGradient id="currentColor" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor="var(--main-color-light)"
                stopOpacity={0.8}
              />
              <stop
                offset="95%"
                stopColor="var(--main-color-light)"
                stopOpacity={0}
              />
            </linearGradient>
            <linearGradient id="previousColor" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor="var(--bkg-light)"
                stopOpacity={0.8}
              />
              <stop offset="95%" stopColor="var(--bkg-light)" stopOpacity={0} />
            </linearGradient>
          </defs>
          {period === "current" && (
            <Area
              type="monotone"
              dataKey="current"
              name={currentLabel}
              stroke="var(--main-color)"
              fillOpacity={1}
              fill="url(#currentColor)"
            />
          )}
          {(period === "previous" || period === "current") && (
            <Area
              type="monotone"
              dataKey="previous"
              name={previousLabel}
              stroke="var(--text-secondary)"
              fillOpacity={1}
              fill="url(#previousColor)"
            />
          )}
        </AreaChart>
      </ResponsiveContainer>
    </ColumnContainer>
  );
};

export default CustomLineChart;
